import { render, staticRenderFns } from "./creditRating.vue?vue&type=template&id=08edc5c2&scoped=true"
import script from "./creditRating.vue?vue&type=script&lang=js"
export * from "./creditRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edc5c2",
  null
  
)

export default component.exports